import React, { useState } from 'react';
import './Header.css';
import logo from '../../assets/kkp-logo.png'; // Adjust the path as necessary

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <img src={logo} alt="KKP Trade LTD" className="header-logo" />
        </div>
        <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
          <a href="#shop" className="nav-link">Shop</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#support" className="nav-link">Support</a>
          <a href="#shop" className="header-cta">Bulk Deals</a>
        </nav>
        <button
          className="hamburger"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="hamburger-icon"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;